<template>
  <div class="card" v-show="currentCardId == 'others'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>通勤時間ほか</h2>
        <p>通勤時間や扶養家族などを入力します</p>
        <p v-if="formatId == 'rirekisho_job_change_old'">
          （以下の見本も参考にし、わからない場合は空欄としておきましょう。）
        </p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div
            class="edit-form-item"
            v-if="
              optionItems.commuteDescription && formatId != 'rirekisho_job_new'
            "
          >
            <div class="item-name">
              通勤手段<small>（電車・バス・自家用車など）</small>
            </div>
            <div class="item-body">
              <el-input
                class="input-md"
                type="textarea"
                placeholder="電車（JR◯◯線）"
                v-model="formatData.commuteDescription"
                :autosize="{ minRows: 1, maxRows: 2 }"
              />
              <div
                class="error attention-limit character"
                v-if="commuteDescriptionOverLimit"
              >
                <i class="el-icon-warning"></i>
                入力可能な文字数をオーバーしています。
              </div>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">通勤時間</div>
            <div class="item-body">
              <el-input
                class="input-xs"
                placeholder=""
                title="時間"
                type="number"
                v-model="formatData.commuteHours"
              />
              時間
              <el-input
                class="input-xs"
                type="number"
                placeholder=""
                title="分"
                v-model="formatData.commuteMinutes"
              />
              分
            </div>
            <div class="item-name">扶養家族（配偶者を除く）</div>
            <div class="item-body">
              <el-input
                class="input-xs"
                placeholder=""
                title="扶養家族の人数"
                type="number"
                v-model="formatData.spouseNumber"
              />
              人
            </div>
            <div class="item-name">配偶者</div>
            <div class="item-body">
              <el-radio v-model="formatData.hasSpouse" :label="true">
                あり</el-radio
              >
              <el-radio v-model="formatData.hasSpouse" :label="false">
                なし</el-radio
              >
            </div>
            <div class="item-name">配偶者の扶養義務</div>
            <div class="item-body">
              <el-radio v-model="formatData.underDutyToSupport" :label="true"
                >あり</el-radio
              >
              <el-radio v-model="formatData.underDutyToSupport" :label="false"
                >なし</el-radio
              >
            </div>
            <br />
            <div
              class="item-name"
              v-if="
                formatId == 'rirekisho_job_new' ||
                formatId == 'rirekisho_job_new_single'
              "
            >
              あなたは留学生ですか。
            </div>
            <div
              class="item-body"
              v-if="
                formatId == 'rirekisho_job_new' ||
                formatId == 'rirekisho_job_new_single'
              "
            >
              <el-radio v-model="formatData.foreignStudent" :label="true"
                >はい</el-radio
              >
              <el-radio v-model="formatData.foreignStudent" :label="false"
                >いいえ</el-radio
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="formatId == 'rirekisho_job_change_old'">
        <p class="guidetxt">見本（参考に作成しましょう）</p>
        <img
          src="/static/img/rirekishoguide/guide07.png"
          alt="通勤時間ほか"
          class="guideimg"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'

defineProps<{
  currentCardId?: string
  formatId?: string
  optionItems: Record<string, unknown>
}>()

type FormLibWithCharCount = {
  charCount: (value: string | undefined) => number
}

const { formLib: formLibRaw } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & FormLibWithCharCount
const formatData = useRirekishoFormatData()

const commuteDescriptionOverLimit = computed(
  () => formLib.charCount(formatData.commuteDescription) > 84
)
</script>

<style lang="scss" scoped>
@import '@/assets/scss/format-edit/rirekisho-guide';

/*
 * 共通スタイルの `.card-header + .card-content { border-top: ... }` は
 * ステップによって隣接する / しないで出方が分かれてしまう。
 * このフローでは「出さない」側（多数派）にそろえる。
 */
.card-header + .card-content {
  border-top: none;
}
</style>
